import axios from "@/axios.js";
import hr from "../../http/requests/hrms/index.js";
import lk from "../../http/requests/lookup/index.js";
import photoUpload from "../../http/requests/photo/index.js";
export default {
  registerUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log("PAYLOAD");
      console.log(payload);
      axios
        .post("/api/account/register", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEmployeeByUserId({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getEmployeeByUserId(userId)
        .then((response) => {
          commit("GET_EMPLOYEEBYUSERID", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllEmployee({ commit }, payload) {
    return new Promise((resolve, reject) => {
      hr.getAllEmployee(payload.pageNumber, payload.pageSize)
        .then((response) => {
          commit("GET_ALL_EMPLOYEE", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllApproversByUserId({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllApproversByUserId(userId)
        .then((response) => {
          commit("GET_ALL_APPROVERSBYUSERID", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateUserProfile({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/account/profile", item)
        .then((response) => {
          commit("UPDATE_ACCOUNTPROFILE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // /////////////////////////////////////////////
  // ROLES
  // /////////////////////////////////////////////
  getAllRoles({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/roles")
        .then((response) => {
          commit("GET_ALLROLES", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddAccreditation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/accreditation", item)
        .then((response) => {
          commit("ADD_ACCREDITATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateAccreditation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/accreditation", item)
        .then((response) => {
          commit("UPDATE_ACCREDITATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteAccreditation({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/accreditation/${id}`)
        .then((response) => {
          commit("DELETE_ACCREDITATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAccreditation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllAccreditation(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_ACCREDITATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddApprovers({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/approvers", item)
        .then((response) => {
          commit("ADD_APPROVERS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateApprovers({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/approvers", item)
        .then((response) => {
          commit("UPDATE_APPROVERS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteApprovers({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/approvers/${id}`)
        .then((response) => {
          commit("DELETE_APPROVERS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddAssociation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/association", item)
        .then((response) => {
          commit("ADD_ASSOCIATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateAssociation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/association", item)
        .then((response) => {
          commit("UPDATE_ASSOCIATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteAssociation({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/association/${id}`)
        .then((response) => {
          commit("DELETE_ASSOCIATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllAssociation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllAssociation(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_ASSOCIATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddBankInformation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/bankInformation", item)
        .then((response) => {
          commit("ADD_BANKINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateBankInformation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/bankInformation", item)
        .then((response) => {
          commit("UPDATE_BANKINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteBankInformation({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/bankInformation/${id}`)
        .then((response) => {
          commit("DELETE_BANKINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllBankInformation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllBankInformation(userId)
        .then((response) => {
          commit("GET_ALL_BANKINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddBenefits({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/benefits", item)
        .then((response) => {
          commit("ADD_BENEFITS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateBenefits({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/benefits", item)
        .then((response) => {
          commit("UPDATE_BENEFITS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteBenefits({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/benefits/${id}`)
        .then((response) => {
          commit("DELETE_BENEFITS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllBenefits({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllBenefits(userId)
        .then((response) => {
          commit("GET_ALL_BENEFITS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddClaimsLimit({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/claimsLimit", item)
        .then((response) => {
          commit("ADD_CLAIMSLIMIT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateClaimsLimit({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/claimsLimit", item)
        .then((response) => {
          commit("UPDATE_CLAIMSLIMIT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteClaimsLimit({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/claimsLimit/${id}`)
        .then((response) => {
          commit("DELETE_CLAIMSLIMIT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllClaimsLimit({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllClaimsLimit(userId)
        .then((response) => {
          commit("GET_ALL_CLAIMSLIMIT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddContactReferences({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/contactReferences", item)
        .then((response) => {
          commit("ADD_CONTACTREFERENCES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateContactReferences({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/contactReferences", item)
        .then((response) => {
          commit("UPDATE_CONTACTREFERENCES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteContactReferences({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/contactReferences/${id}`)
        .then((response) => {
          commit("DELETE_CONTACTREFERENCES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllContactReferences({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllContactReferences(userId)
        .then((response) => {
          commit("GET_ALL_CONTACTREFERENCES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddEducation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/education", item)
        .then((response) => {
          commit("ADD_EDUCATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateEducation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/education", item)
        .then((response) => {
          commit("UPDATE_EDUCATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteEducation({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/education/${id}`)
        .then((response) => {
          commit("DELETE_EDUCATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllEducation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllEducation(userId)
        .then((response) => {
          commit("GET_ALL_EDUCATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddFamilyInformation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/familyInformation", item)
        .then((response) => {
          commit("ADD_FAMILYINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateFamilyInformation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/familyInformation", item)
        .then((response) => {
          commit("UPDATE_FAMILYINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteFamilyInformation({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/familyInformation/${id}`)
        .then((response) => {
          commit("DELETE_FAMILYINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllFamilyInformation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllFamilyInformation(userId)
        .then((response) => {
          commit("GET_ALL_FAMILYINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddIdentification({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/identification", item)
        .then((response) => {
          commit("ADD_IDENTIFICATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateIdentification({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/identification", item)
        .then((response) => {
          commit("UPDATE_IDENTIFICATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteIdentification({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/identification/${id}`)
        .then((response) => {
          commit("DELETE_IDENTIFICATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllIdentification({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllIdentification(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_IDENTIFICATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddInformation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/information", item)
        .then((response) => {
          commit("ADD_INFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateInformation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/information", item)
        .then((response) => {
          commit("UPDATE_INFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteInformation({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/information/${id}`)
        .then((response) => {
          commit("DELETE_INFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllInformation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllInformation(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_INFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddJobHistory({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/jobHistory", item)
        .then((response) => {
          commit("ADD_JOBHISTORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateJobHistory({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/jobHistory", item)
        .then((response) => {
          commit("UPDATE_JOBHISTORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteJobHistory({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/jobHistory/${id}`)
        .then((response) => {
          commit("DELETE_JOBHISTORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllJobHistory({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllJobHistory(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_JOBHISTORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddLeaveBalance({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/leaveBalance", item)
        .then((response) => {
          commit("ADD_LEAVEBALANCE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateLeaveBalance({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/leaveBalance", item)
        .then((response) => {
          commit("UPDATE_LEAVEBALANCE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteLeaveBalance({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/leaveBalance/${id}`)
        .then((response) => {
          commit("DELETE_LEAVEBALANCE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLeaveBalance({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllLeaveBalance(userId)
        .then((response) => {
          // console.log('GET_ALL_LEAVEBALANCE')
          // console.log(response)
          commit("GET_ALL_LEAVEBALANCE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddLeaveBenefits({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/leaveBenefits", item)
        .then((response) => {
          commit("ADD_LEAVEBENEFITS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateLeaveBenefits({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/leaveBenefits", item)
        .then((response) => {
          commit("UPDATE_LEAVEBENEFITS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteLeaveBenefits({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/leaveBenefits/${id}`)
        .then((response) => {
          commit("DELETE_LEAVEBENEFITS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllLeaveBenefits({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllLeaveBenefits(userId)
        .then((response) => {
          // //console.log(response.data.data)
          commit("GET_ALL_LEAVEBENEFITS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddMedical({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/medical", item)
        .then((response) => {
          commit("ADD_MEDICAL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateMedical({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/medical", item)
        .then((response) => {
          commit("UPDATE_MEDICAL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteMedical({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/medical/${id}`)
        .then((response) => {
          commit("DELETE_MEDICAL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllMedical({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllMedical(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_MEDICAL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddPerformance({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/performance", item)
        .then((response) => {
          commit("ADD_PERFORMANCE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdatePerformance({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/performance", item)
        .then((response) => {
          commit("UPDATE_PERFORMANCE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeletePerformance({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/performance/${id}`)
        .then((response) => {
          commit("DELETE_PERFORMANCE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllPerformance({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllPerformance(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_PERFORMANCE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddSalaryInformation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/salaryInformation", item)
        .then((response) => {
          commit("ADD_SALARYINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateSalaryInformation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/salaryInformation", item)
        .then((response) => {
          commit("UPDATE_SALARYINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteSalaryInformation({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/salaryInformation/${id}`)
        .then((response) => {
          commit("DELETE_SALARYINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllSalaryInformation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllSalaryInformation(userId)
        .then((response) => {
          commit("GET_ALL_SALARYINFORMATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddSalary({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/salary", item)
        .then((response) => {
          commit("ADD_SALARY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateSalary({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/salary", item)
        .then((response) => {
          commit("UPDATE_SALARY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteSalary({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/salary/${id}`)
        .then((response) => {
          commit("DELETE_SALARY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllSalary({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllSalary(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_SALARY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddTraining({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/training", item)
        .then((response) => {
          commit("ADD_TRAINING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateTraining({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/training", item)
        .then((response) => {
          commit("UPDATE_TRAINING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteTraining({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/training/${id}`)
        .then((response) => {
          commit("DELETE_TRAINING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllTraining({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllTraining(userId)
        .then((response) => {
          //console.log(response.data.data)
          commit("GET_ALL_TRAINING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  AddViolation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/violation", item)
        .then((response) => {
          commit("ADD_VIOLATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  UpdateViolation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/hrms/violation", item)
        .then((response) => {
          commit("UPDATE_VIOLATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  DeleteViolation({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/hrms/violation/${id}`)
        .then((response) => {
          commit("DELETE_VIOLATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllViolation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllViolation(userId)
        .then((response) => {
          commit("GET_ALL_VIOLATION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  //EMPLOYEE SCHEDULE
  getAllEmployeeScheduleByCreateScheduleId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/schedule/getallemployeeschedulebycreatescheduleid", {
          params: {
            createScheduleId: payload.createScheduleId,
            userId: payload.userId,
          },
        })
        .then((response) => {
          commit("CURRENT_SCHEDULE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEmployeeScheduleByDateToday({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/schedule/getschedulebydatetoday", {
          params: {
            scheduleDate: payload.dateToday,
            userId: payload.userId,
          },
        })
        .then((response) => {
          commit("GET_EMPLOYEESCHEDULEBYDATETODAY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  //CONFIRMATION EMAIL
  resendConfirmation({ commit }, email) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/account/resendconfirmation/${email}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  autoUpdatePassword({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/account/autoupdatepassword/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllPrevCompany({ commit }, userId) {
    return new Promise((resolve, reject) => {
      hr.getAllPrevCompany(userId)
        .then((response) => {
          commit("GET_PREVCOMPANY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addPreviousCompany({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/hrms/previousCompany", items)
        .then((response) => {
          commit("ADD_PREVIOUS_COMPANY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  disableEmployee({ commit }, payload) {
  return new Promise((resolve, reject) => {
    console.log("disabled:", payload);
    axios.post(`/api/account/disableEmployee?userId=${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
},
  updatePreviousCompany({ commit }, items) {
    return new Promise((resolve, reject) => {
      console.log("Items to be updated:", items);
      axios
        .put("/api/hrms/previousCompany", items)
        .then((response) => {
          commit("UPDATE_PREVIOUSCOMPANY", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  
};
